import useBulkCollectionData from '../hooks/useBulkCollectionData'

interface Props {
  codes: string[]
}

const CollectionDataFetcher: React.FC<Props> = (props: Props) => {
  const { codes } = props

  useBulkCollectionData({ codes })

  return null
}

export default CollectionDataFetcher
